export enum Kind {
  Metadata = 0,
  Text = 1,
  RecommendRelay = 2,
  Follows = 3,
  EncryptedDirectMessage = 4,
  EventDeletion = 5,
  Repost = 6,
  Reaction = 7,
  BadgeAward = 8,
  GenericRepost = 16,
  Media = 20,
  Video = 21,
  ShortVideo = 22,
  PublicMessage = 24,
  ChannelCreation = 40,
  ChannelMetadata = 41,
  ChannelMessage = 42,
  ChannelHideMessage = 43,
  ChannelMuteUser = 44,
  Blank = 255,
  Comment = 1111,
  VoiceMessage = 1222,
  Report = 1984,
  ZapRequest = 9734,
  ZapReceipt = 9735,
  Highlight = 9802,
  Mutelist = 10000,
  PinnedNotes = 10001,
  RelayList = 10002,
  BookmarkList = 10003,
  Communities = 10004,
  PublicChats = 10005,
  BlockedRelays = 10006,
  SearchRelays = 10007,
  RelayFavorites = 10012,
  Interests = 10015,
  MediaFollows = 10020,
  Emojis = 10030,
  TrustedAssertions = 10040,
  DMRelays = 10050,
  BlossomServerList = 10063,
  NIP96ServerList = 10096,
  MonitorDiscovery = 10166,
  ClientAuth = 22242,
  // replaceable
  FollowSets = 30000,
  RelaySets = 30002,
  BookmarkSets = 30003,
  CurationSets = 30004,
  CurationSetsVideo = 30005,
  CurationSetsPicture = 30006,
  MuteSets = 30007,
  BadgeDefinition = 30008,
  ProfileBadge = 30009,
  InterestSets = 30015,
  Article = 30023,
  EmojiSets = 30030,
  ReleaseArtifactSets = 30063,
  AppCurationSets = 30267,
  TrustedAssertionUser = 30382,
  TrustedList = 30392,
  Calendar = 31924,
  StarterPack = 39089,
  MediaStarterPack = 39092,
  RelayMonitor = 30166,
  NostrConnect = 24133,
  DraftWrap = 31234,
}

export const KIND_LABELS: Record<number, string> = {
  [Kind.Mutelist]: 'Mute List',
  [Kind.PinnedNotes]: 'Pinned Notes',
  [Kind.RelayList]: 'Relay List',
  [Kind.BookmarkList]: 'Bookmarks',
  [Kind.Communities]: 'Communities',
  [Kind.PublicChats]: 'Public Chats',
  [Kind.BlockedRelays]: 'Blocked Relays',
  [Kind.SearchRelays]: 'Search Relays',
  [Kind.RelayFavorites]: 'Relay Feeds',
  [Kind.Interests]: 'Interests',
  [Kind.MediaFollows]: 'Media Follows',
  [Kind.Emojis]: 'Emojis',
  [Kind.TrustedAssertions]: 'Trusted Assertions',
  [Kind.DMRelays]: 'DM Relays',
  [Kind.FollowSets]: 'Follow Sets',
  [Kind.RelaySets]: 'Relay Sets',
  [Kind.BookmarkSets]: 'Bookmark Sets',
  [Kind.CurationSets]: 'Curation Sets (Articles)',
  [Kind.CurationSetsVideo]: 'Curation Sets (Videos)',
  [Kind.CurationSetsPicture]: 'Curation Sets (Pictures)',
  [Kind.MuteSets]: 'Mute Sets',
  [Kind.InterestSets]: 'Interest Sets',
  [Kind.EmojiSets]: 'Emoji Sets',
  [Kind.ReleaseArtifactSets]: 'Release Artifact Sets',
  [Kind.AppCurationSets]: 'App Curation Sets',
  [Kind.Calendar]: 'Calendar',
  [Kind.StarterPack]: 'Starter Packs',
  [Kind.MediaStarterPack]: 'Media Starter Packs',
}

export const LIST_KIND_MAP: Record<number, true> = {
  [Kind.Mutelist]: true,
  [Kind.PinnedNotes]: true,
  [Kind.RelayList]: true,
  [Kind.BookmarkList]: true,
  [Kind.Communities]: true,
  [Kind.PublicChats]: true,
  [Kind.BlockedRelays]: true,
  [Kind.SearchRelays]: true,
  [Kind.RelayFavorites]: true,
  [Kind.Interests]: true,
  [Kind.MediaFollows]: true,
  [Kind.Emojis]: true,
  [Kind.TrustedAssertions]: true,
  [Kind.DMRelays]: true,
  [Kind.FollowSets]: true,
  [Kind.RelaySets]: true,
  [Kind.BookmarkSets]: true,
  [Kind.CurationSets]: true,
  [Kind.CurationSetsVideo]: true,
  [Kind.CurationSetsPicture]: true,
  [Kind.MuteSets]: true,
  [Kind.InterestSets]: true,
  [Kind.EmojiSets]: true,
  [Kind.ReleaseArtifactSets]: true,
  [Kind.AppCurationSets]: true,
  [Kind.Calendar]: true,
  [Kind.StarterPack]: true,
  [Kind.MediaStarterPack]: true,
}

export function isListKind(kind: number): boolean {
  return kind in LIST_KIND_MAP
}
